global.fetch_cache = {};

export const cachedFetch = async (url,params) => {
    try {
        var stringified = JSON.stringify(url) + JSON.stringify(params);
        if(global.fetch_cache[stringified]){
            return global.fetch_cache[stringified]
        }else{
            var response = await fetch(url,params)
            global.fetch_cache[stringified] = await response.json();
            return global.fetch_cache[stringified];
        }
    } catch (e) {
        return false;
    }
};
